export default __webpack_public_path__ + "static/media/vaea.667bf8ac.png";